import { PermissionCheck } from "@/src/components/permissions/PermissionCheck";
import {
  PermissionsResourceType,
  useQuestionQuery,
} from "@/src/graphql/generated";
import useGqlClient from "@/src/hooks/useGqlClient";
import { links } from "@/src/utils/links";
import { truncateText } from "@/src/utils/truncateText";
import { MessageCircleQuestionIcon } from "lucide-react";
import { NavLink, useParams } from "react-router-dom";

export function QuestionPill(props: {
  question?: { id: string; title: string };
  /** @deprecated Prefer `question` with title to avoid a network fetch */
  questionId?: string;
  style?: "assistant";
}) {
  const { dealId } = useParams<{ dealId: string }>();
  const client = useGqlClient();

  const questionId = props.question?.id ?? props.questionId ?? "";
  const needsFetch = !props.question?.title && questionId !== "";

  const questionQuery = useQuestionQuery(
    client,
    { id: questionId },
    { enabled: needsFetch },
  );

  const question = props.question?.title
    ? props.question
    : questionQuery.data?.question
      ? {
          id: questionQuery.data.question.id,
          title: questionQuery.data.question.title,
        }
      : null;

  if (!question) {
    return null;
  }

  const isAssistantStyle = props.style === "assistant";
  const containerClasses = isAssistantStyle
    ? "cursor-pointer hover:border-gray-400 bg-white hover:shadow-sm relative flex items-center rounded-2xl border px-2 py-1"
    : "rounded-full bg-blue-100 hover:bg-blue-200 text-blue-700 px-2 py-1 text-xs flex items-center gap-x-1";

  const textClasses = isAssistantStyle
    ? "text-xs ml-1 text-gray-800 truncate"
    : "";

  return (
    <PermissionCheck
      input={{
        permissionKey: "questions:view",
        resource: {
          resourceID: question.id,
          resourceType: PermissionsResourceType.Question,
        },
      }}
    >
      <NavLink
        to={links.questionLink(question, dealId)}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className={containerClasses}>
          <MessageCircleQuestionIcon className="w-4 h-4" />
          <span className={textClasses || undefined}>
            {truncateText(question.title, 30)}
          </span>
        </div>
      </NavLink>
    </PermissionCheck>
  );
}
